import { useEffect, useState } from 'react'
import { useAuth } from './contexts/AuthContext'
import { supabase } from './supabase'
import Login from './pages/Login'
import ResetPassword from './pages/ResetPassword'
import CoordinationApp from './pages/coordination/CoordinationApp'
import SuperviseurApp from './pages/superviseur/SuperviseurApp'
import './index.css'

export default function App() {
  const { user, profile, loading } = useAuth()
  const [isRecovery, setIsRecovery] = useState(false)

  useEffect(() => {
    // Détecter si on est sur un lien de récupération de mot de passe
    const hash = window.location.hash
    if (hash.includes('type=recovery')) {
      setIsRecovery(true)
    }

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setIsRecovery(true)
      if (event === 'SIGNED_IN') setIsRecovery(false)
    })

    return () => subscription.unsubscribe()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div style={{display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh'}}>
        <div className="spinner" />
      </div>
    )
  }

  if (isRecovery) return <ResetPassword />

  if (!user || !profile) return <Login />

  if (!profile.actif) {
    return (
      <div style={{display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'var(--cream)'}}>
        <div className="card" style={{maxWidth:400, textAlign:'center'}}>
          <h3 style={{marginBottom:12}}>Compte désactivé</h3>
          <p className="text-muted">Votre compte a été désactivé. Contactez la coordination.</p>
        </div>
      </div>
    )
  }

  if (profile.role === 'coordination') return <CoordinationApp />
  if (profile.role === 'superviseur') return <SuperviseurApp />

  return <Login />
}
